function GenericError(message) {
  this.name = 'GenericError'
  this.message = (message !== undefined) ? 'Generic Error - ' + message : 'I\' a teapot - Something that I don\'t understand happend'
  this.code = '418'
  // Use V8's native method if available, otherwise fallback
  if ('captureStackTrace' in Error) { Error.captureStackTrace(this, GenericError) }
  else { this.stack = (new Error()).stack }
}
GenericError.prototype = Object.create(Error.prototype)
GenericError.prototype.constructor = GenericError

function NotFoundError(message) {
  this.name = 'NotFoundError'
  this.message = (message !== undefined) ? 'Not Found - ' + message : 'Not Found'
  this.code = '404'
}
NotFoundError.prototype = Object.create(GenericError.prototype)
NotFoundError.prototype.constructor = NotFoundError

function AccessDeniedError(message) {
  this.name = 'AccessDeniedError'
  this.message = (message !== undefined) ? 'Access Denied - ' + message : 'Access Denied'
  this.code = '403'
}
AccessDeniedError.prototype = Object.create(GenericError.prototype)
AccessDeniedError.prototype.constructor = AccessDeniedError

function AuthorizationRequiredError(message) {
  this.name = 'AuthorizationRequiredError'
  this.message = (message !== undefined) ? 'Authorization required - ' + message : 'Authorization required'
  this.code = '401'
}
AuthorizationRequiredError.prototype = Object.create(GenericError.prototype)
AuthorizationRequiredError.prototype.constructor = AuthorizationRequiredError

function BadRequestError(message) {
  this.name = 'BadRequestError'
  this.message = (message !== undefined) ? 'Bad Request - ' + message : 'Bad Request'
  this.code = '400'
}
BadRequestError.prototype = Object.create(GenericError.prototype)
BadRequestError.prototype.constructor = BadRequestError

function RequestTimeoutError(message) {
  this.name = 'RequestTimeoutError'
  this.message = (message !== undefined) ? 'Request timeout - ' + message : 'Request Timeout'
  this.code = '408'
}
RequestTimeoutError.prototype = Object.create(GenericError.prototype)
RequestTimeoutError.prototype.constructor = RequestTimeoutError

function SystemError(message, parent) {
  this.name = 'SystemError'
  if (parent !== undefined) {
    this.message = message ? `System Error - ${message} :: ${parent.message}` : `System Error - ${parent.message}`
  }
  else {
    this.message = message ? 'System Error - ' + message : 'System Error'
  }
  this.code = '500'
  if (parent !== undefined) {
    this.stack = parent.stack
  }
}
SystemError.prototype = GenericError.prototype
SystemError.prototype.constructor = SystemError

export {
  NotFoundError,
  AccessDeniedError,
  AuthorizationRequiredError,
  BadRequestError,
  GenericError,
  RequestTimeoutError,
  SystemError
}
